module.exports = __webpack_public_path__ + "static/media/service.e81d63ca.png";